<!-- Brand row -->
<div class="sb-brand" [class.sb-brand--mini]="sidebarService.showMinisidebar">
  <img
    *ngIf="!sidebarService.showMinisidebar"
    src="assets/images/Logo.png"
    alt="saftelmah"
    class="sb-logo-img"
  />
  <button
    type="button"
    class="sb-collapse-btn"
    (click)="toggleCollapse()"
    [title]="sidebarService.showMinisidebar ? 'Expandir menú' : 'Colapsar menú'"
  >
    <app-sidebar-icon name="sidebar" [size]="16"></app-sidebar-icon>
  </button>
</div>

<!-- Workspace selector with empresa dropdown -->
<div
  *ngIf="!sidebarService.showMinisidebar"
  class="sb-workspace"
  ngbDropdown
  placement="bottom-start"
  #empresaDrop="ngbDropdown"
>
  <button class="ws-trigger" type="button" ngbDropdownToggle>
    <div class="ws-avatar">{{ empresaInitials }}</div>
    <div class="ws-info">
      <div class="ws-label">Empresa</div>
      <div class="ws-name" [title]="requestServ.empresa">{{ requestServ.empresa }}</div>
    </div>
    <span class="ws-chev">
      <app-sidebar-icon name="chev-down" [size]="13"></app-sidebar-icon>
    </span>
  </button>

  <div ngbDropdownMenu class="sb-empresa-menu">
    <div class="sb-empresa-search">
      <span class="sb-empresa-search-icon">
        <app-sidebar-icon name="search" [size]="14"></app-sidebar-icon>
      </span>
      <input
        type="text"
        placeholder="Buscar empresa..."
        [(ngModel)]="filterEmpresas"
        (click)="$event.stopPropagation()"
      />
    </div>

    <div class="sb-empresa-list">
      <button
        *ngFor="let item of empresas | multifilter:['nombre']:filterEmpresas"
        type="button"
        class="sb-empresa-item"
        [class.expirada]="item.expirado"
        [disabled]="item.expirado"
        (click)="!item.expirado && cambiarEmpresa(item.id); empresaDrop.close()"
      >
        <div class="sb-empresa-avatar">{{ initials(item.nombre) }}</div>
        <div class="sb-empresa-info">
          <div class="sb-empresa-name">{{ item.nombre }}</div>
          <span *ngIf="item.expirado" class="sb-empresa-pill">Expirada</span>
        </div>
      </button>

      <div *ngIf="(empresas | multifilter:['nombre']:filterEmpresas)?.length === 0" class="sb-empresa-empty">
        Sin resultados
      </div>
    </div>
  </div>
</div>

<!-- Search -->
<div class="sb-search" *ngIf="!sidebarService.showMinisidebar">
  <span class="sb-search-icon">
    <app-sidebar-icon name="search" [size]="14"></app-sidebar-icon>
  </span>
  <input type="text" placeholder="Buscar módulo..." [(ngModel)]="searchTerm" />
  <kbd>⌘K</kbd>
</div>

<!-- Nav -->
<nav *ngIf="!loadingc" class="sb-nav">
  <ng-container *ngFor="let section of sections; trackBy: trackBySection">
    <ng-container *ngIf="sectionVisible(section)">
      <div class="sb-section-label" *ngIf="!sidebarService.showMinisidebar">{{ section.title }}</div>
      <ul class="menu-root">
        <ng-container
          *ngTemplateOutlet="renderItems; context: { $implicit: section.items, level: 0, flyout: false }"
        ></ng-container>
      </ul>
    </ng-container>
  </ng-container>
</nav>

<!-- User footer -->
<div class="sb-user" (click)="requestServ.cerrarSesion()" title="Cerrar sesión">
  <div class="sb-user-avatar">{{ userInitials }}</div>
  <div class="sb-user-info">
    <div class="sb-user-name">{{ nombre }}</div>
    <div class="sb-user-role">{{ rol }}</div>
  </div>
  <span class="sb-user-status" title="En línea"></span>
</div>

<!-- Recursive items template -->
<ng-template #renderItems let-items let-level="level" let-flyout="flyout">
  <ng-container *ngFor="let item of items; trackBy: trackByKey">
    <li
      *ngIf="!item.extralink && canShow(item) && matchesSearch(item)"
      class="menu-item"
      [class.has-children]="hasChildren(item)"
      [class.is-open]="isExpanded(item)"
      [class.is-active]="isActive(item)"
      [attr.data-level]="level"
      (mouseenter)="flyout ? hoverExpand(item) : null"
      (mouseleave)="flyout ? hoverCollapse(item) : null"
    >
      <div class="row-item">
        <button
          *ngIf="hasChildren(item)"
          type="button"
          class="btn-item"
          (click)="onMenuClick(item, $event, flyout, level)"
          [attr.aria-expanded]="isExpanded(item)"
          [attr.title]="sidebarService.showMinisidebar ? item.title : null"
          [attr.data-label]="item.title"
          (mouseenter)="!flyout && level===0 && sidebarService.showMinisidebar && !isTouch ? openFlyout(item, $event) : null"
          (mouseleave)="!flyout && level===0 && sidebarService.showMinisidebar && !isTouch ? scheduleFlyoutClose() : null"
        >
          <span *ngIf="level === 0 && item.icon" class="sb-item-icon">
            <img *ngIf="iconSrc(item.icon)" [src]="iconSrc(item.icon)" [alt]="item.title" />
            <app-sidebar-icon *ngIf="!iconSrc(item.icon)" [name]="item.icon" [size]="17"></app-sidebar-icon>
          </span>
          <span class="sb-item-label">{{ item.title }}</span>
          <span *ngIf="item.badge" class="sb-item-badge muted">{{ item.badge }}</span>
          <span class="sb-item-chev" [class.rotated]="isExpanded(item)">
            <app-sidebar-icon name="chev-right" [size]="13"></app-sidebar-icon>
          </span>
        </button>

        <a
          *ngIf="!hasChildren(item)"
          class="link-item"
          [routerLink]="[item.path]"
          routerLinkActive="router-link-active"
          (click)="closeSidebarIfMobile(); closeFlyout()"
          [attr.title]="sidebarService.showMinisidebar ? item.title : null"
          [attr.data-label]="item.title"
          (mouseenter)="level===0 && sidebarService.showMinisidebar ? closeFlyout() : null"
        >
          <span *ngIf="level === 0 && item.icon" class="sb-item-icon">
            <img *ngIf="iconSrc(item.icon)" [src]="iconSrc(item.icon)" [alt]="item.title" />
            <app-sidebar-icon *ngIf="!iconSrc(item.icon)" [name]="item.icon" [size]="17"></app-sidebar-icon>
          </span>
          <span class="sb-item-label">{{ item.title }}</span>
          <span *ngIf="item.badge" class="sb-item-badge">{{ item.badge }}</span>
        </a>
      </div>

      <ul class="submenu" *ngIf="hasChildren(item)" [class.open]="flyout ? isFlyoutOpen(item) : isExpanded(item)">
        <ng-container
          *ngTemplateOutlet="renderItems; context: { $implicit: item.submenu, level: level + 1, flyout: flyout }"
        ></ng-container>
      </ul>
    </li>
  </ng-container>
</ng-template>

<!-- Flyout overlay (modo colapsado) -->
<div
  class="flyout-overlay"
  *ngIf="sidebarService.showMinisidebar && flyoutRoot"
  [ngStyle]="{ top: flyoutTop + 'px', left: flyoutLeft + 'px' }"
  (mouseenter)="cancelFlyoutClose()"
  (mouseleave)="scheduleFlyoutClose()"
>
  <div class="flyout-head">
    <span class="flyout-title">{{ flyoutRoot.title }}</span>
    <button type="button" class="flyout-close" (click)="closeFlyout()">×</button>
  </div>
  <ul class="flyout-root">
    <ng-container
      *ngTemplateOutlet="renderItems; context: { $implicit: flyoutRoot.submenu, level: 1, flyout: true }"
    ></ng-container>
  </ul>
</div>
